import { Box, Divider, IconButton, List, ListItem, Tab, Tabs, TextField, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useState } from 'react'
import { ThemeContext } from '../../context/ThemeContext'
import { useTranslation } from 'react-i18next'
import HistoryFilter from '../components/history/HistoryFilter'
import { useDispatch, useSelector } from 'react-redux'
import { setSelectedTabType } from '../../store/Slices/historySlice'
import HistorySummary from '../components/HistorySummary'
import OrderSummary from '../components/OrderSummary'
import moment from 'moment'
import { HiBars2 } from 'react-icons/hi2'
import SideDrawer from '../components/SidebarMenu'
import { IoSearchOutline } from 'react-icons/io5';
import useHistoryCell from '../../components/tablecells/History'
import useOrderCell from '../../components/tablecells/Orders';
import useTransactionCell from '../../components/tablecells/Transaction';

export default function History() {
  const { darkMode } = useContext(ThemeContext)
  const { t } = useTranslation()
  const [selectedTab, setSelectedTab] = useState("Trades")
  const dispatch = useDispatch()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const decimalPlaces = 2;
  const { symbols } = useSelector(state => state.watchlist)
  const filteredHistory = useSelector((state) => state.history.filteredHistory)
  const [searchQuery, setSearchQuery] = useState('');
  const bgImage = '/BG.png'
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [searchVisible, setSearchVisible] = useState(false);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const HistoryCell = useHistoryCell();
  const OrderCell = useOrderCell();
  const TransactionCell = useTransactionCell();

  const handleExpandClick = (index) => {
    setExpandedIndex(prev => (prev === index ? null : index));
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue)
    console.log(newValue);
    dispatch(setSelectedTabType(newValue))
  }

  // const tabData = filteredHistory
  const tabData = filteredHistory.filter(item => {
    const query = searchQuery.toLowerCase()
    return (
      item.symbolName?.toLowerCase().includes(query) ||
      item.ticket?.toString().toLowerCase().includes(query)
    )
  })

  const total = filteredHistory.length
  const canceled = filteredHistory.filter(item => item.status === 'CANCEL').length
  const typeMap = {
    1: "Deposit",
    2: "Adjustment",
    3: "Credit In",
    4: "Withdrawal",
    5: "Credit Out",
  };
  const { UserCompleteDetails } = useSelector(state => state.user);

  const offsetToMinutes = (offset) => {
    const [hours, minutes, seconds] = offset.split(":").map(Number);
    return hours * 60 + minutes + Math.sign(hours) * (seconds > 0 ? 1 : 0);
  };

  const formatDateTime = (serverDateTime) => {
    if (!serverDateTime) return "--";

    const serverTime = moment.parseZone(serverDateTime);
    const serverOffsetMin = offsetToMinutes(UserCompleteDetails?.serverGMTOffset || "00:00:00");
    const clientOffsetMin = offsetToMinutes(UserCompleteDetails?.gmtOffset || "00:00:00");
    const diffOffset = clientOffsetMin - serverOffsetMin;

    return serverTime.add(diffOffset, "minutes").format("DD-MM-YYYY HH:mm:ss");
  };
  const getDetailsComponent = (item) => {
    let columns = [];
    if (selectedTab === "Trades") columns = HistoryCell;
    if (selectedTab === "Orders") columns = OrderCell;
    if (selectedTab === "Transaction") columns = TransactionCell;

    const excludedKeys = ["dateTime", "symbolName"];
    const filteredCols = columns.filter(col => !excludedKeys.includes(col.dataIndex));

    return (
      <Box sx={{ p: 2, pt: 0, bgcolor: darkMode ? '#1e2731' : '#f9f9f9' }}>
        {filteredCols.map((col, colIndex) => {
          let value = col.render(item[col.dataIndex], item);

          if (col.dataIndex === "comment") {
            value = item.status ? item.status !== "CANCEL" ? `${item.status} - #${item.closeTicket ?? item.openTicket}` : item.status : item.comment || "";
          }

          let color = "inherit";
          if (col.dataIndex === "type") {
            color = item.type === 1 ? "primary.main" : "secondary.main";
          } else if (col.dataIndex === "profitLoss") {
            color = item.profitLoss < 0 ? "var(--red)" : item.profitLoss > 0 ? "var(--green)" : "inherit";
          } else if (col.dataIndex === "openTicket") {
            color = item.status === "DONE" ? "green" : item.status === "CANCEL" ? "red" : "inherit";
          }

          return (
            <Box key={colIndex} sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="caption">{col.title}:</Typography>
              <Typography variant="caption" sx={{ color }}>{value}</Typography>
            </Box>
          );
        })}
      </Box>
    );
  };

  return (
    <>
      <Box sx={{ height: '100%', overflow: 'hidden', backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center', display: 'flex', flexDirection: 'column', }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, }}>
          <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: 1.5, p: 0.5 }}>
            <HiBars2 onClick={() => setDrawerOpen(true)} style={{ fontSize: 24, color: 'white' }} />
            <Typography color='white' variant='body1' sx={{ fontSize: 18 }}> {t('history')}</Typography>
          </Box>
          <Box display="flex" justifyContent="space-between" alignItems="center" pr={2} py={1} gap={1}>
            {/* <HistoryMenu /> */}
            <HistoryFilter />
          </Box>
        </Box>

        <Box sx={{ backgroundColor: 'white', height: '100%', }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: darkMode ? "#202933" : "#f1f1f1", }}>

            <Tabs value={selectedTab} onChange={handleTabChange} textColor="primary" indicatorColor="primary">
              <Tab label={t('trades')} value="Trades" sx={{ textTransform: 'none' }} />
              <Tab label={t('orders')} value="Orders" sx={{ textTransform: 'none' }} />
              <Tab label={t('transaction')} value="Transaction" sx={{ textTransform: 'none' }} />
            </Tabs>
            <Box sx={{ display: 'flex', alignItems: 'center', ml: 2 }}>
              {searchVisible ? (
                <TextField variant="outlined" size="small" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} placeholder={t('search')} sx={{ width: 160, transition: 'width 0.3s ease', backgroundColor: darkMode ? '#2d3748' : '#fff', borderRadius: 1, ml: 1, '& .MuiOutlinedInput-root': { px: 1, py: 0.5, fontSize: 13, }, }} />
              ) : null}
              <IconButton onClick={() => setSearchVisible(!searchVisible)} size="small" sx={{ ml: 1 }}>
                <IoSearchOutline style={{ fontSize: 20, color: darkMode ? '#fff' : '#000' }} />
              </IconButton>
            </Box>
          </Box>
          {(selectedTab == "Trades" || selectedTab == "Transaction") && <HistorySummary />}
          {selectedTab == "Orders" && <OrderSummary total={total} canceled={canceled} />}

          {tabData.length > 0 ? (
            <List sx={{ height: '100%', flex: 1, overflow: 'auto', paddingTop: 1, paddingBottom: isMobile ? 25 : 0, overflowY: selectedTab === "Transaction" ? 'auto' : 'initial', maxHeight: selectedTab === "Transaction" ? 'calc(100vh - 300px)' : 'none', }}>
              {(selectedTab == "Trades" || selectedTab == "Orders") && tabData.map((item, index) => (
                <React.Fragment key={index}>
                  <ListItem onClick={() => handleExpandClick(index)} alignItems="flex-start" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                      <Box display="flex" alignItems="center" gap={0.5}>
                        <Typography fontWeight="bold" sx={{ color: darkMode ? "var(--white)" : "var(--black)" }}>{item.symbolName}</Typography>
                        <Typography variant='caption' sx={{ color: item.side == 1 ? 'var(--primary)' : 'salmon', fontWeight: 'bold', textTransform: 'capitalize' }}>
                          {item.type !== undefined && selectedTab == "Orders"
                            ? (() => {
                              let label;
                              switch (item.type) {
                                case 0: label = t("new"); break;
                                case 7: label = t("BuyLimit"); break;
                                case 8: label = t("BuyStop"); break;
                                case 6: label = t("SellLimit"); break;
                                case 9: label = t("SellStop"); break;
                                case 11: label = t("SL/TP"); break;
                                default: label = item.type;
                              }
                              return label;
                            })()
                            : item.side == 1 ? "Buy" : "Sell"
                          }
                        </Typography>
                        <Typography variant='caption' sx={{ color: darkMode ? "var(--white)" : "var(--black)" }}>#{item.ticket}</Typography>

                      </Box>
                      <Typography variant="body2" color='textSecondary' sx={{ mt: 0.5 }}>{item?.amount ? item.amount.toFixed(decimalPlaces) : '0.00'} at {item?.openPrice ? item?.openPrice.toFixed(symbols[item?.symbolId].digits) : '0.00'}</Typography>
                    </Box>

                    <Box textAlign="right">
                      <Typography color='textSecondary' sx={{ fontWeight: 'bold', color: item.profitLoss < 0 ? 'var(--red)' : item.profitLoss > 0 ? 'var(--green)' : 'inherit', }}>{item.profitLoss}</Typography>
                      <Typography variant="body2" color='textSecondary'>{formatDateTime(item.dateTime)}</Typography>
                    </Box>
                  </ListItem>
                  {expandedIndex === index && getDetailsComponent(item)}

                  <Divider component="li" />
                </React.Fragment>
              ))}

              {selectedTab == "Transaction" && tabData.map((item, index) => (
                <React.Fragment key={index}>
                  <ListItem onClick={() => handleExpandClick(index)} alignItems="flex-start" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                      <Box display="flex" alignItems="center">
                        <Typography color='primary' sx={{ fontWeight: 'bold', textTransform: 'capitalize' }}> {typeMap[item.type] || "Unknown"}</Typography>
                      </Box>
                      <Typography variant="body2" color='textSecondary'>{formatDateTime(item.dateTime)}</Typography>

                    </Box>

                    <Box textAlign="right">
                      <Typography variant="body1" color='textSecondary' sx={{ mt: 0.5 }}>{item.amount.toFixed(decimalPlaces)}</Typography>

                    </Box>
                  </ListItem>
                  {expandedIndex === index && getDetailsComponent(item)}
                  <Divider component="li" />
                </React.Fragment>
              ))}
            </List>
          ) : (
            <Typography textAlign="center" mt={2} sx={{ color: darkMode ? "var(--lightText)" : "var(--darkText)" }}>{t('noData')}</Typography>
          )}

        </Box>
      </Box>
      <SideDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </>
  )
}
